<template>
    <div class="login-style-2">
        <div class="container">
            <div class="acr-auth-container">
                <div class="acr-auth-content">
                    <slot></slot>
                </div>
                <div class="acr-auth-bg bg-cover bg-center dark-overlay dark-overlay-2" :style="`background: ${url}`">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                url:`url(${require('@/assets/images/login.jpg')})`
            }
        }
    }
</script>
<style lang="css" scoped>
    .input-span-placeholder{padding-right:32px !important}
    input.vs-inputx.vs-input--input.normal.hasIcon {
        padding-right: 32px;
        padding-left: 1rem;
    }
    .Input_Active{
        font-size: .7rem;
        margin-top: -25px;
        padding-right: .5rem !important;
        right: 0;
    }
    .acr-auth-content form {
        max-width: 500px;
        width: 250px;
        margin: 0 auto;
    }
</style>